import React from 'react';

interface HeaderProps {
  title?: string;
  githubUrl?: string;
}

const Header: React.FC<HeaderProps> = ({
  title = 'MultiscalePCP',
  githubUrl = 'https://github.com/yourusername/multiscale-pcp',
}) => {
  return (
    <header className="header" role="banner">
      <div className="container header-container">
        <div className="logo">
          <span className="logo-icon" aria-hidden="true">
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="24"
              height="24"
              viewBox="0 0 24 24"
              fill="none"
              stroke="currentColor"
              strokeWidth="2"
              strokeLinecap="round"
              strokeLinejoin="round"
            >
              <polyline points="22 12 18 12 15 21 9 3 6 12 2 12"></polyline>
            </svg>
          </span>
          <span>{title}</span>
        </div>

        <nav className="nav" aria-label="Main Navigation">
          <a href="#visualization" className="nav-link active" aria-current="page">
            Visualization
          </a>
          <a href="#about" className="nav-link">
            About
          </a>
          <a
            href={githubUrl}
            target="_blank"
            rel="noopener noreferrer"
            className="nav-link"
            aria-label="GitHub Repository (opens in new tab)"
          >
            <span>GitHub</span>
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="16"
              height="16"
              viewBox="0 0 24 24"
              fill="none"
              stroke="currentColor"
              strokeWidth="2"
              strokeLinecap="round"
              strokeLinejoin="round"
              className="external-link-icon"
              aria-hidden="true"
            >
              <path d="M18 13v6a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2V8a2 2 0 0 1 2-2h6"></path>
              <polyline points="15 3 21 3 21 9"></polyline>
              <line x1="10" y1="14" x2="21" y2="3"></line>
            </svg>
          </a>
        </nav>
      </div>
    </header>
  );
};

export default Header;
